<rtn-appointment-header></rtn-appointment-header>
<div class="container customer-portal" role="main" [style.min-height.px]="minHeight">
  <router-outlet></router-outlet>
</div>
<rtn-common-footer></rtn-common-footer>